define('components/util/tool-menu',[
    'jquery',
    'lib/jquery.scrollTo.min'
],function($){

    function toolMenuFactory( settings ){
        var _this = this;
        var timeCanClose, isOpen = false;
        var currentAtElement;


        // settings per toolmenu controller
        var persist = settings.persist || false; // stays open on click outside tool menu.
        var defaultClassName = settings.className || ""; // added to tool-menu element.
        var autoClose = settings.autoClose || -1; //when set the window autocloses after given milliseconds
        var hideCloseButton = settings.hideCloseButton || false; //do you want to show the close button or not
        var setting_position = settings.position || undefined; //can be left|right. will overwrite the default positioning
        var setting_clearContent = settings.clearContent || true; //for backwards compatiblility. if true, then replace the content of popup. if false append to existing content

        var closeButtonString = '';
        if(!hideCloseButton){
          closeButtonString = '<span class="tool-menu-close"><i class="ico ico-close"></i></span>';
        }
        var toolMenuElement = jQuery(
            '<div class="tool-menu">'.concat(
                '<span class="tool-menu-pointer"></span>',
                closeButtonString,
                '<div class="tool-menu-content" data-handler="analytics-searchresult"></div>',
            '</div>'
            )).hide().appendTo('.container');

        var toolMenuPointer = toolMenuElement.find('.tool-menu-pointer');
        var toolMenuContent = toolMenuElement.find('.tool-menu-content');

        var toolMenu = {
          create: toolMenuFactory,

          show: function( content, atElement, className ){
            toolMenuElement[0].className = ['tool-menu',className||defaultClassName||''].join(' ');
            toolMenuElement.appendTo('.container'); // make sure it's on top.
            timeCanClose = +new Date() + 200;
            toolMenuContent.children().remove();

            if(setting_clearContent){
              toolMenuContent.html(content);
            } else {
              toolMenuContent.append(content);
            }

            toolMenuElement.show();

            position(atElement);
            currentAtElement = atElement;
            isOpen = true;

            // if(autoClose > 0){
            //   setTimeout(function(){
            //     toolMenu.hide();
            //   }, autoClose);
            // }
          },

          scrollTo: function(settings){
            $.scrollTo(currentAtElement,500,settings);
          },

          hide: function(){
            if ( timeCanClose < (+new Date()) ) {
              toolMenuElement.hide();
              isOpen = false;
              currentAtElement = null;
            }
          },

          isCurrent: function( atElement ){
            return atElement === currentAtElement;
          },

          /**
           * returns the asked setting.
           * @param  {string} value the name of the setting
           * @return {any}       the value of the asked setting
           */

          getSetting: function(value) {
            if(settings[value] !== undefined){
              return settings[value];
            }

            return undefined;
          }
        };

        toolMenuElement.on('click','.tool-menu-close',toolMenu.hide);

        $(document.documentElement).on('click',function(e){
          if ( !persist && !$(e.target).closest('.tool-menu').length ) {
            toolMenu.hide();
          }
        });

        $(window).on('resize',function(){
          if ( isOpen ) {
            toolMenu.hide();
          }
        });

        function position( atElement ){

            atElement = jQuery( atElement );

            var width = toolMenuElement.width();
            var pointerWidth = toolMenuPointer.outerWidth();
            var offset = atElement.offset();
            var xOffset = offset.left + ( atElement.outerWidth() / 2 );
            var elementWidth = atElement.outerWidth();
            var yOffset = offset.top + atElement.outerHeight();
            var clientWidth = document.body.clientWidth;

            // X axis only
            var pointerOffset = 0;



            if ( clientWidth <= Math.max(width,320) ) {

                toolMenuElement.css({
                    top: yOffset,
                    left: 5,
                    right: 5
                });

                toolMenuPointer.css({
                    left: xOffset - 5
                });

                return;
            }

            // position tooltip and align pointer with relativeEl.
            if(setting_position === "left"){
              xOffset = offset.left - (width - elementWidth);
              pointerOffset = width - 20;
            } else if ( xOffset > ( clientWidth / 2 )  ) {
                // orientation right
                xOffset = xOffset - width + 20;
                pointerOffset = width - 20;
            } else {
                // orientation left/center
                xOffset = xOffset - 20;
                pointerOffset = 20;
            }

            toolMenuElement.css({
                top: yOffset,
                left: Math.max( xOffset, 5 ),
                right: 'auto'
            });

            toolMenuPointer.css({
                left: pointerOffset
            });

        }

        return toolMenu;

    }

    return toolMenuFactory({
        className: "standard-tool-menu",
        persist: false
    });

});

